<template>
  <div class="centerArea_wrapper">
    <div class="entry_wrapper wrapper background">
      <div class="self-video">
        <video class="mirror" autoplay muted playsinline :srcObject.prop="selfStream" />
        <div class="stream-setting inner">
          <div
            v-if="enableMic"
            class="stream-setting-button btn"
            :class="{inactive: !micDeviceList.length || deviceNotAllowed}"
            @click="enableMic = false"
          >
            <div>
              <fa-icon icon="microphone" />
            </div>
            <div>音声</div>
          </div>
          <div v-else class="stream-setting-button off" :class="{inactive: !micDeviceList.length || deviceNotAllowed}" @click="enableMic = true">
            <div>
              <fa-icon icon="microphone-slash" />
            </div>
            <div>
              音声
            </div>
          </div>
          <div
            v-if="enableCamera"
            class="stream-setting-button btn"
            :class="{inactive: !videoDeviceList.length || deviceNotAllowed}"
            @click="enableCamera = false"
          >
            <div>
              <fa-icon icon="video" />
            </div>
            <div>
              映像
            </div>
          </div>
          <div v-else class="stream-setting-button off" :class="{inactive: !videoDeviceList.length || deviceNotAllowed}" @click="enableCamera = true">
            <div>
              <fa-icon icon="video-slash" />
            </div>
            <div>
              映像
            </div>
          </div>
        </div>
      </div>
      <div class="entry" v-if="$route.params.roomSlug">
        <p>参加する準備は整いましたか？</p>
        <!-- toDo: 自分以外の参加者を取得する → 対応チケット:https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-137-->
        <div class="device-setting">
          <div class="deviceErrorMessage" v-if="message.stream">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.stream" />
          </div>
          <div class="deviceErrorMessage" v-if="message.device">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.device" />
          </div>
          <div class="device-item">
            <label for="camera-device">
              カメラ
            </label>
            <select id="camera-device" v-model="videoDeviceId">
              <option v-for="(device, key) in videoDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
            </select>
          </div>
          <div class="device-item">
            <label for="mic-device">
              マイク
            </label>
            <select id="mic-device" v-model="micDeviceId">
              <option v-for="(device, key) in micDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
            </select>
          </div>
        </div>
        <Participants v-if="participants.length" :participants="participants" />
        <p v-else :style="{margin: '16px 0'}">あなた以外にまだ誰も参加していません</p>
        <div class="entry_btn">
          <router-link
            tag="button"
            :to="{name: 'Hall', params: {hallSlug: $route.params.hallSlug}}"
            class="ext_btn btn soft"
            :style="{margin: '4px'}"
          >
            <div class="inner">
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </div>
          </router-link>
          <router-link
            v-if="micDeviceList.length && !deviceNotAllowed"
            tag="button"
            class="btn"
            :to="{name: 'YRoom', params: {slug: $store.getters['event/slug'], hallSlug: $route.params.hallSlug, roomSlug: $route.params.roomSlug}}"
            :style="{margin: '4px'}"
          >
            参加する
          </router-link>
        </div>
      </div>
      <div class="entry talk-room-entry" v-else>
        <p>参加する準備は整いましたか？</p>
        <div class="device-setting">
          <div class="deviceErrorMessage" v-if="message.stream">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.stream" />
          </div>
          <div class="deviceErrorMessage" v-if="message.device">
            <fa-icon icon="exclamation-circle" class="notification-icon" />
            <span v-html="message.device" />
          </div>
          <div class="device-item">
            <label for="camera-device">
              カメラ
            </label>
            <select id="camera-device" v-model="videoDeviceId">
              <option v-for="(device, key) in videoDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
            </select>
          </div>
          <div class="device-item">
            <label for="mic-device">
              マイク
            </label>
            <select id="mic-device" v-model="micDeviceId">
              <option v-for="(device, key) in micDeviceList" :value="device.deviceId" :key="key">{{ device.label }}</option>
            </select>
          </div>
        </div>

        <div class="entry_btn">
          <router-link tag="button" :to="{name: 'Top', params: {slug: $route.params.slug}}" class="ext_btn btn soft" :style="{margin: '4px'}">
            <div class="inner">
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </div>
          </router-link>
          <router-link
            v-if="micDeviceList.length"
            tag="button"
            class="btn"
            :to="{name: 'TalkRoom', params: {slug: $store.getters['event/slug'], roomName: $route.params.roomName}}"
            :style="{margin: '4px'}"
          >
            参加する
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Participants from "../elements/Participants"
import Lang from "../../skyway/lang.js"

export default {
  name: "Entry",
  components: {Participants},
  created: function() {
    this.init()
  },
  beforeDestroy() {
    this.disconnect()
  },
  data() {
    return {
      selfStream: {},
      message: {},
      deviceNotAllowed: false
    }
  },
  watch: {
    videoDeviceId: function() {
      this.changeDevice()
    },
    micDeviceId: function() {
      this.changeDevice()
    }
  },
  computed: {
    enableCamera: {
      get: function() {
        return this.$store.getters["stream/enableCamera"]
      },
      set: function(newValue) {
        if (!this.videoDeviceList.length) return

        this.$store.commit("stream/setEnableCamera", newValue)
        this.updateCamera()
      }
    },
    enableMic: {
      get: function() {
        return this.$store.getters["stream/enableMic"]
      },
      set: function(newValue) {
        if (!this.micDeviceList.length) return

        this.$store.commit("stream/setEnableMic", newValue)
        this.updateMic()
      }
    },
    participants() {
      return this.$store.getters["participants/getByHallAndRoomSlug"](this.$route.params.hallSlug, this.$route.params.roomSlug)
    },
    videoDeviceList: function() {
      return this.$store.getters["device/videoDeviceList"]
    },
    micDeviceList: function() {
      return this.$store.getters["device/micDeviceList"]
    },
    videoDeviceId: {
      get: function() {
        return this.$store.getters["device/videoDeviceId"]
      },
      set: function(newValue) {
        this.$store.commit("device/setVideoDeviceId", newValue)
      }
    },
    micDeviceId: {
      get: function() {
        return this.$store.getters["device/micDeviceId"]
      },
      set: function(newValue) {
        this.$store.commit("device/setMicDeviceId", newValue)
      }
    }
  },
  methods: {
    init: async function() {
      this.roomId = this.type === "mesh" ? this.$route.params.roomName : this.$route.params.roomSlug
      await this.deviceSetUp()

      try {
        this.selfStream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: {ideal: 640},
            height: {ideal: 360},
            deviceId: this.videoDeviceId
          },
          audio: {deviceId: this.videoDeviceId}
        })
      } catch (error) {
        try {
          this.message["device"] = Lang.errors.general_entry()
          // カメラが取得できない場合はオーディオのみで接続
          this.selfStream = await navigator.mediaDevices.getUserMedia({video: false, audio: {deviceId: this.videoDeviceId}})
        } catch (error) {
          console.error(error)
          if (error.message === "Permission denied") {
            this.message["device"] = Lang.errors.permission_denied()
            this.deviceNotAllowed = true
          } else {
            this.message["device"] = Lang.errors.general_entry()
          }
        }
      }
      this.updateCamera()
      this.updateMic()
      this.deviceError()
      this.getDeviceList()
    },
    deviceSetUp: async function() {
      navigator.mediaDevices.addEventListener("devicechange", () => {
        this.getDeviceList()
      })
      await this.getDeviceList()
    },
    getDeviceList: async function() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      this.$store.commit("device/setVideoDeviceList", _.filter(devices, {kind: "videoinput"}))
      this.$store.commit("device/setMicDeviceList", _.filter(devices, {kind: "audioinput"}))

      if (!this.videoDeviceList.length) {
        this.enableCamera = false
        this.message["device"] = Lang.alert.audio_only()
      }
      if (!this.micDeviceList.length) {
        this.enableMic = false
        this.message["device"] = Lang.errors.no_mic()
      }

      if (this.micDeviceList.length)
        if (!_.find(this.videoDeviceList, {deviceId: this.videoDeviceId}) && this.videoDeviceList.length) {
          this.videoDeviceId = this.videoDeviceList[0].deviceId
        }
      if (!_.find(this.micDeviceList, {deviceId: this.micDeviceId}) && this.micDeviceList.length) {
        this.micDeviceId = this.micDeviceList[0].deviceId
      }
    },
    changeDevice: async function() {
      this.selfStream.getTracks().forEach(track => {
        track.stop()
      })

      try {
        this.selfStream = await navigator.mediaDevices.getUserMedia({
          video: {deviceId: this.videoDeviceId},
          audio: {deviceId: this.micDeviceId}
        })
        this.message = {}
      } catch (e) {
        console.log(e)
        this.message["stream"] = Lang.errors.general_entry()
      }

      // カメラのON/OFFを反映
      this.updateCamera()
      this.updateMic()
    },
    updateCamera: function() {
      if (!this.videoDeviceList.length) return

      this.selfStream.getVideoTracks().forEach(track => {
        track.enabled = this.enableCamera
      })
    },
    updateMic: function() {
      if (!this.micDeviceList.length) return

      this.selfStream.getAudioTracks().forEach(track => {
        track.enabled = this.enableMic
      })
    },
    setEnableCamera: function(boolean) {
      this.$store.commit("stream/setEnableCamera", boolean)
    },
    setEnableMic: function(boolean) {
      this.$store.commit("stream/setEnableMic", boolean)
    },
    deviceError: function() {
      if (_.isEmpty(this.selfStream)) return

      const videoTrack = this.selfStream.getVideoTracks()[0]
      const audioTrack = this.selfStream.getAudioTracks()[0]
      videoTrack.onended = () => {
        this.message["stream"] = Lang.errors.general_entry()
      }
      audioTrack.onended = () => {
        this.message["stream"] = Lang.errors.general_entry()
      }
    },
    disconnect: function() {
      this.selfStream.getTracks().forEach(track => {
        track.stop()
      })
    }
  }
}
</script>
